import { render, staticRenderFns } from "./m-popup-bottom-list.vue?vue&type=template&id=184fdf2a"
import script from "./m-popup-bottom-list.vue?vue&type=script&lang=js"
export * from "./m-popup-bottom-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports